import React, { useEffect, useState, FormEvent } from "react";
import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import { ValidationErrorMessages } from "utils/Error";
import { notify, ToastType } from "utils/Toast";
import { phoneNumberCheck } from "utils/rejex";
import { defaultLocation } from "components/Map/map";
import { defaultLocationType } from "components/Map/map";
import { useNavigate } from "react-router-dom";
import { URL_Route } from "urlRouts";
import ImageCompress from "utils/ImageCompress";

interface Props {
  Component: any;
}

export interface ErrorAddProperty {
  advisor: string | null;
  landlord: string | null;
  phone: string | null;
  mobile: string | null;
  region: string | null;
  address: string | null;
  property: string | null;
  unitInFloor: string | null;
  floor: string | null;
  numOfFloors: string | null;
  area: string | null;
  bed: string | null;
  bath: string | null;
  buildingAge: string | null;
  monthlyRent: string | null;
  kitchen: string | null;
  floorCover: string | null;
  telLine: string | null;
  garageCount: string | null;
}

const EditProperty: React.FC<Props> = ({ Component }) => {
  const [data, setData] = useState<any>([]);
  const [dataGot, setDataGot] = useState<boolean>(false);
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [allowToAdd, setAllowToAdd] = useState<boolean>(true);
  const [advisor, setAdvisor] = useState<string>("");
  const [landlord, setLandlord] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [region, setRegion] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [property, setProperty] = useState<string>("");
  const [shopCenter, setShopCenter] = useState<string>("");
  const [unitInFloor, setUnitInFloor] = useState<string>("");
  const [floor, setFloor] = useState<string>("");
  const [numOfFloors, setNumOfFloors] = useState<string>("");
  const [area, setArea] = useState<string>("");
  const [bed, setBed] = useState<string>("");
  const [bath, setBath] = useState<string>("");
  const [buildingAge, setBuildingAge] = useState<string>("");
  const [renovated, setRenovated] = useState<boolean>(false);
  const [descriptionAboutThisProperty, setDescriptionAboutThisProperty] =
    useState<string>("");
  const [fullFurnished, setFullFurnished] = useState<boolean>(false);
  const [semiFurnished, setSemiFurnished] = useState<boolean>(false);
  const [monthlyRent, setMonthlyRent] = useState<string>("0");
  const [kitchen, setKitchen] = useState<string>("");
  const [advertisement, setAdvertisement] = useState<boolean>(false);
  const [floorCover, setFloorCover] = useState<string>("");
  const [telLine, setTelLine] = useState<string>("");
  const [storage, setStorage] = useState<boolean>(false);
  const [firePlace, setFirePlace] = useState<boolean>(false);
  const [seoDescription, setSeoDescription] = useState<string>("");
  const [seoTitle, setSeoTitle] = useState<string>("");
  const [location, setLocation] =
    useState<defaultLocationType>(defaultLocation);
  const [facility, setFacility] = useState<any>();
  const [forceUpdate, setForceUpdate] = useState<number>(0);
  const [error, setError] = useState<ErrorAddProperty>({
    advisor: null,
    landlord: null,
    phone: null,
    mobile: null,
    region: null,
    address: null,
    property: null,
    unitInFloor: null,
    floor: null,
    numOfFloors: null,
    area: null,
    bed: null,
    bath: null,
    buildingAge: null,
    monthlyRent: null,
    kitchen: null,
    floorCover: null,
    telLine: null,
    garageCount: null,
  });
  const [propertyId, setPropertyId] = useState<string>();
  const [selectedPropertyData, setSelectedPropertyData] = useState<any>();
  const [selectedPropertyStatus, setSelectedPropertyStatus] =
    useState<string>();
  const [statusList, setStatusList] = useState<any>([
    { id: 21, title: "Not Approve" },
    { id: 22, title: "Approve" },
    { id: 25, title: "Archived" },
  ]);
  const [showImageArrey, setShowImageArrey] = useState<any>([]);
  const [forceUpdateShowImageArrey, setForceUpdateShowImageArrey] =
    useState<boolean>(true);
  const [allowToCallSortFunction, setAllowToCallSortFunction] =
    useState<boolean>(true);
  const [garageCount, setGarageCount] = useState<string>("0");
  const [isItHotProperty, setIsItHotProperty] = useState<boolean>(false);
  const [monthlyRentAfter, setMonthlyRentAfter] = useState<string>("0");
  const navigate = useNavigate();

  const changePropertyStatus = (status: any) => {
    setSelectedPropertyStatus(status);
    const changeStatusObj = {
      depositId: propertyId,
      stateId: status,
    };
    Axios(
      AxiosMethodEnum.post,
      Axios_Route.DEPOSITE_CHANGE_STATUS,
      changeStatusObj
    ).then(({ response, success }) => {
      if (success) {
        notify(
          ValidationErrorMessages.SUCCESS.ITEM_STATUS_UPDATED,
          ToastType.success
        );
      }
    });
  };

  useEffect(() => {
    if (fullFurnished) {
      setSemiFurnished(false);
    }
  }, [fullFurnished]);

  useEffect(() => {
    if (semiFurnished) {
      setFullFurnished(false);
    }
  }, [semiFurnished]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id: any = queryParams.get("property-id");
    setPropertyId(id);

    Axios(
      AxiosMethodEnum.get,
      Axios_Route.DEPOSITE_EDIT + `?depositId=${id}`
    ).then(({ response, success }) => {
      if (success) {
        let propertyData = response;
        setSelectedPropertyData(propertyData);
        setSelectedPropertyStatus(propertyData.statusId);
        setAdvisor(propertyData.adviser_id);
        setLandlord(propertyData.ownerName);
        setPhone(propertyData.ownerPhone);
        setMobile(propertyData.ownerMobile);
        setAddress(propertyData.address);
        setRegion(propertyData.region_id);
        setProperty(propertyData.propertyType_id);
        setShopCenter(propertyData.shopCenterCount);
        setUnitInFloor(propertyData.unitInFloor);
        setFloor(propertyData.floorCount);
        setNumOfFloors(propertyData.floorNumber);
        setArea(propertyData.buildingArea);
        setBed(propertyData.bedCount);
        setBath(propertyData.bathCount);
        setBuildingAge(propertyData.buildingAge);
        setDescriptionAboutThisProperty(propertyData.description);
        setRenovated(propertyData.renovate);
        setFullFurnished(propertyData.furnished);
        setSemiFurnished(propertyData.semiFurnished);
        setMonthlyRent(propertyData.monthlyRent);
        setKitchen(propertyData.kitchenService_id);
        setFloorCover(propertyData.floorCover_id);
        setTelLine(propertyData.telLineCount);
        setAdvertisement(propertyData.isAdvertisement);
        setStorage(propertyData.storage);
        setFirePlace(propertyData.firePlug);
        setSeoTitle(propertyData.seoTitle);
        setSeoDescription(propertyData.seoDescription);
        setLocation({
          lat: propertyData.latitude,
          lng: propertyData.longitude,
        });
        setGarageCount(propertyData.garageCount);
        setIsItHotProperty(propertyData.hotProperty);
        setMonthlyRentAfter(propertyData.monthlyRentAfter);

        let showImageArrey: any = [];
        propertyData.depositImg.forEach((item: any, key: number) => {
          showImageArrey.push({
            image: item,
            sort: key + 1,
            uploadedUrl: item,
          });
        });
        setShowImageArrey(showImageArrey);

        Axios(AxiosMethodEnum.get, Axios_Route.DEPOSITE_ADD_INDEX).then(
          ({ response, success }) => {
            if (success) {
              setData(response);
              let Facility = response.listFacility;
              Facility.forEach((item: any, key: any) => {
                propertyData.depositFac.includes(item.id)
                  ? (item.status = true)
                  : (item.status = false);
              });
              setFacility(Facility);
              setDataGot(true);
            }
          }
        );
      }
    });
  }, []);

  useEffect(() => {
    if (!isItHotProperty) {
      setMonthlyRentAfter("");
    }
  }, [isItHotProperty]);

  useEffect(() => {
    if (showErrors) {
      errorHandling();
    }
  }, [
    advisor,
    landlord,
    phone,
    mobile,
    region,
    address,
    property,
    unitInFloor,
    floor,
    numOfFloors,
    area,
    bed,
    bath,
    buildingAge,
    monthlyRent,
    kitchen,
    floorCover,
    telLine,
    garageCount,
  ]);

  const errorHandling = () => {
    let AllowToContinue = true;

    if (advisor.length === 0) {
      error.advisor = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.advisor = null;
    }

    if (landlord.length === 0) {
      error.landlord = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.landlord = null;
    }

    if (phone.length === 0) {
      error.phone = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.phone = null;
    }

    if (!phoneNumberCheck(mobile)) {
      error.mobile = ValidationErrorMessages.ERRORS.MOBILE_VALIDATION_ERROR;
      AllowToContinue = false;
    } else {
      error.mobile = null;
    }

    if (mobile.length === 0) {
      error.mobile = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else if (!phoneNumberCheck(mobile)) {
      error.mobile = ValidationErrorMessages.ERRORS.MOBILE_VALIDATION_ERROR;
      AllowToContinue = false;
    } else {
      error.mobile = null;
    }

    if (region.length === 0) {
      error.region = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.region = null;
    }

    if (address.length === 0) {
      error.address = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.address = null;
    }

    if (property.length === 0) {
      error.property = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.property = null;
    }

    if (unitInFloor.length === 0) {
      error.unitInFloor = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.unitInFloor = null;
    }

    if (floor.length === 0) {
      error.floor = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.floor = null;
    }

    if (numOfFloors.length === 0) {
      error.numOfFloors = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.numOfFloors = null;
    }

    if (area.length === 0) {
      error.area = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.area = null;
    }

    if (bed.length === 0) {
      error.bed = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.bed = null;
    }

    if (bath.length === 0) {
      error.bath = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.bath = null;
    }

    if (buildingAge.length === 0) {
      error.buildingAge = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.buildingAge = null;
    }

    if (monthlyRent.length === 0) {
      error.monthlyRent = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.monthlyRent = null;
    }

    if (monthlyRentAfter !== undefined && monthlyRentAfter !== null) {
      if (Number(monthlyRent) <= Number(monthlyRentAfter)) {
        error.monthlyRent =
          ValidationErrorMessages.ERRORS.MONTHLY_RENT_SMALLER_THAN_HOT;
        AllowToContinue = false;
      } else {
        error.monthlyRent = null;
      }
    }

    if (kitchen.length === 0) {
      error.kitchen = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.kitchen = null;
    }

    if (floorCover.length === 0) {
      error.floorCover = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.floorCover = null;
    }

    if (telLine.length === 0) {
      error.telLine = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.telLine = null;
    }

    if (garageCount.length === 0) {
      error.garageCount = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.garageCount = null;
    }

    setError({ ...error });

    return AllowToContinue;
  };

  const facilityChangeCustom = (id: number) => {
    let currentStatus = facility.find((item: any) => item.id === id).status;
    let facilityNew = facility;
    facilityNew.find((item: any) => item.id === id).status = !currentStatus;

    setFacility(facilityNew);
    setForceUpdate(forceUpdate + 1);
  };

  const depositFacIdFunc = () => {
    let responseId: Array<any> = [];
    let responseTitle: Array<any> = [];
    facility.map((item: any) => {
      if (item.status === true) {
        responseId.push(item.id);
        responseTitle.push(item.title);
      }
    });
    return { responseId, responseTitle };
  };

  const editPropertyHandler = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandling();

    if (!AllowToContinue) {
      notify(
        Object.values(error).find((index) => index !== null),
        ToastType.error
      );
      window.scrollTo({ top: 0 });
    }

    const depositFacilityObj = depositFacIdFunc();

    var imageObjects: any = [];
    showImageArrey.forEach((item: any) => {
      imageObjects.push(item.uploadedUrl);
    });

    let garage: boolean;
    if (
      garageCount === "0" ||
      Number(garageCount) === 0 ||
      garageCount === null
    ) {
      garage = false;
    } else {
      garage = true;
    }

    const PropertyObj = {
      id: propertyId,
      seoDescription: seoDescription,
      seoTitle: seoTitle,
      latitude: location.lat,
      longitude: location.lng,
      depositFac: depositFacilityObj.responseId,
      depositFac_title: depositFacilityObj.responseTitle,
      depositImg: imageObjects,
      baseImagePath: imageObjects[0],
      ownerName: landlord,
      ownerPhone: phone,
      ownerMobile: mobile,
      region_id: region,
      address: address,
      propertyType_id: property,
      unitInFloor: unitInFloor,
      floorCount: floor,
      floorNumber: numOfFloors,
      buildingArea: area,
      bedCount: bed,
      bathCount: bath,
      buildingAge: buildingAge,
      monthlyRent: monthlyRent,
      kitchenService_id: kitchen,
      floorCover_id: floorCover,
      telLineCount: telLine,
      adviser_id: advisor,
      adviser_title: data.listAdvisor.find((item: any) => item.id === advisor)
        .title,
      region_title: data.listRegion.find((item: any) => item.id === region)
        .title,
      propertyType_title: data.listPropertys.find(
        (item: any) => item.id === property
      ).title,
      shopCenterCount: shopCenter,
      description: descriptionAboutThisProperty,
      semiFurnished: semiFurnished,
      furnished: fullFurnished,
      kitchenService_title: data.listKitchenService.find(
        (item: any) => item.id === kitchen
      ).title,
      floorCover_title: data.listFloorCover.find(
        (item: any) => item.id === floorCover
      ).title,
      firePlug: firePlace,
      isAdvertisement: advertisement,
      garage: garage,
      storage: storage,
      renovate: renovated,
      statusId: selectedPropertyStatus,
      monthlyRentAfter: monthlyRentAfter,
      hotProperty: isItHotProperty,
      garageCount: garageCount,
    };

    if (AllowToContinue && allowToAdd) {
      setAllowToAdd(false);

      Axios(AxiosMethodEnum.post, Axios_Route.DEPOSITE_EDIT, PropertyObj).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            notify(
              ValidationErrorMessages.SUCCESS.NEW_ITEM_EDITED,
              ToastType.success
            );
            navigate(URL_Route.Property_List);
            window.scrollTo({ top: 0 });
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  async function uploadImageFunc(e: any) {
    let imageFormData = new FormData();

    let result: any = await ImageCompress(e.target.files[0]);
    if (result === false) {
      return;
    }

    imageFormData.append("image", result, e.target.files[0].name + ".jpg");
    Axios(
      AxiosMethodEnum.post,
      Axios_Route.DEPOSITE_UPLOAD_IMAGE,
      imageFormData,
      "multipart/form-data"
    ).then(({ response, success }) => {
      setAllowToAdd(true);
      if (success) {
        let newShowImageArrey = showImageArrey;
        newShowImageArrey.push({
          image: e.target.files[0],
          sort: showImageArrey.length + 1,
          uploadedUrl: response,
        });
        setShowImageArrey(newShowImageArrey);
        setForceUpdate(forceUpdate + 1);

        notify(
          ValidationErrorMessages.SUCCESS.IMAGE_UPLOADED_SUCCESSFULLY,
          ToastType.success
        );
      } else if (!success) {
        notify(response.error, ToastType.error);
      }
    });
  }

  const sortImage = (e: any, key: number) => {
    if (allowToCallSortFunction) {
      setTimeout(() => {
        let arrey = showImageArrey;
        let newSortPosition = e.target.value;
        arrey.forEach((item: any) => {
          if (arrey[key].sort > newSortPosition) {
            if (item.sort >= newSortPosition && item.sort < arrey[key].sort) {
              item.sort = item.sort + 1;
            }
          } else if (arrey[key].sort < newSortPosition) {
            if (item.sort <= newSortPosition && item.sort > arrey[key].sort) {
              item.sort = item.sort - 1;
            }
          }
        });
        arrey[key].sort = parseInt(newSortPosition);
        setForceUpdateShowImageArrey(false);
        let sortedArrey = arrey.sort((p1: any, p2: any) =>
          p1.sort > p2.sort ? 1 : p1.sort < p2.sort ? -1 : 0
        );
        sortedArrey.forEach((element: any, key: number) => {
          element.sort = key + 1;
        });
        setShowImageArrey(sortedArrey);
        setTimeout(() => {
          setForceUpdateShowImageArrey(true);
          setAllowToCallSortFunction(true);
        }, 1);
      }, 1000);
    }
    setAllowToCallSortFunction(false);
  };

  const removeImageFunc = (sortNumber: number) => {
    setForceUpdateShowImageArrey(false);
    var array = showImageArrey;
    var index = array.indexOf(
      array.find((item: any) => item.sort === sortNumber)
    );
    if (index > -1) {
      array.splice(index, 1);
    }
    array.forEach((element: any, key: number) => {
      element.sort = key + 1;
    });
    setShowImageArrey(array);
    setTimeout(() => {
      setForceUpdateShowImageArrey(true);
    }, 1);
  };

  return (
    <div>
      <Component
        data={data}
        dataGot={dataGot}
        editPropertyHandler={editPropertyHandler}
        error={error}
        setAdvisor={setAdvisor}
        landlord={landlord}
        setLandlord={setLandlord}
        phone={phone}
        setPhone={setPhone}
        mobile={mobile}
        setMobile={setMobile}
        setRegion={setRegion}
        address={address}
        setAddress={setAddress}
        setProperty={setProperty}
        shopCenter={shopCenter}
        setShopCenter={setShopCenter}
        unitInFloor={unitInFloor}
        setUnitInFloor={setUnitInFloor}
        floor={floor}
        setFloor={setFloor}
        numOfFloors={numOfFloors}
        setNumOfFloors={setNumOfFloors}
        area={area}
        setArea={setArea}
        bed={bed}
        setBed={setBed}
        bath={bath}
        setBath={setBath}
        buildingAge={buildingAge}
        setBuildingAge={setBuildingAge}
        renovated={renovated}
        setRenovated={setRenovated}
        descriptionAboutThisProperty={descriptionAboutThisProperty}
        setDescriptionAboutThisProperty={setDescriptionAboutThisProperty}
        fullFurnished={fullFurnished}
        setFullFurnished={setFullFurnished}
        semiFurnished={semiFurnished}
        setSemiFurnished={setSemiFurnished}
        monthlyRent={monthlyRent}
        setMonthlyRent={setMonthlyRent}
        setKitchen={setKitchen}
        setFloorCover={setFloorCover}
        telLine={telLine}
        setTelLine={setTelLine}
        advertisement={advertisement}
        setAdvertisement={setAdvertisement}
        storage={storage}
        setStorage={setStorage}
        firePlace={firePlace}
        setFirePlace={setFirePlace}
        seoDescription={seoDescription}
        setSeoDescription={setSeoDescription}
        seoTitle={seoTitle}
        setSeoTitle={setSeoTitle}
        setLocation={setLocation}
        location={location}
        facility={facility}
        facilityChangeCustom={facilityChangeCustom}
        forceUpdate={forceUpdate}
        advisor={advisor}
        region={region}
        property={property}
        kitchen={kitchen}
        floorCover={floorCover}
        selectedPropertyStatus={selectedPropertyStatus}
        statusList={statusList}
        setSelectedPropertyStatus={setSelectedPropertyStatus}
        changePropertyStatus={changePropertyStatus}
        uploadImageFunc={uploadImageFunc}
        showImageArrey={showImageArrey}
        sortImage={sortImage}
        forceUpdateShowImageArrey={forceUpdateShowImageArrey}
        removeImageFunc={removeImageFunc}
        garageCount={garageCount}
        setGarageCount={setGarageCount}
        isItHotProperty={isItHotProperty}
        setIsItHotProperty={setIsItHotProperty}
        monthlyRentAfter={monthlyRentAfter}
        setMonthlyRentAfter={setMonthlyRentAfter}
      />
    </div>
  );
};

export default EditProperty;
